var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.faq = {
	init : function() {
		var $faq = $('#faq');
		if ($faq.length === 0) return false;

		$('.answer', $faq).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});

		$(window).resize(function() {
			$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});

		$faq.find('.question').click(function() {
			$(this).parent('li').toggleClass('open');
		});
		$faq.find('#cancel').click(function() {
			window.history.back();
		});
	}
};

site.inits.push('site.faq.init()');

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.readspeaker = {
	init:function() {
		$(window).load(function() {
			if ($('#readspeaker_button1').length === 0) return false;

			$('br', '.boxText').addClass('rs_pause');
			$('.entryContent .image', '#calendar').addClass('rs_skip');
			$('span:not(:last-child)', '#news .entryInfo').addClass('rs_pause');

			var $body = $('body');
			var mut = new MutationObserver(function(mutations){
				mutations.forEach(function (mutation) {
					if (mutation.attributeName === "class") {
						var classes = $(mutation.target).prop(mutation.attributeName);

						if (~classes.indexOf('rsplaying') && !$body.hasClass('rsplaying')) {
							$body.addClass('rsplaying');
						}
						else if ((~classes.indexOf('rspaused') || ~classes.indexOf('rsstopped')) && $body.hasClass('rsplaying')) {
							$body.removeClass('rsplaying');
							site.faq.init();
						}
					}
				});
			});
			mut.observe(document.querySelector('#readspeaker_button1'),{
				'attributes': true
			});

		});
	}
};

site.inits.push('site.readspeaker.init()');

site.frontpage = {
	init: function() {
		site.lottery.init();
	}
};

site.stillingar = {
	skip: function() {
		$('a.more', '.frontpage').addClass('ms_skip');
		$('.moreLink a, a.moreLink').addClass('ms_skip');
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.owl.init('#custom-hero .items', {
		loop:false,
		dots: false,
		nav:true,
		navText: ['<span class="sr-only">Skoða fyrri</span>','<span class="sr-only">Skoða næstu</span>'],
		autoplay: false,
		animateOut: 'fadeOut',
		animateIn: 'fadeIn',
		autoplayTimeout: 8000,
		autoplayHoverPause: true,
		touchDrag: true,
		mouseDrag: true,
		items: 1,
		onInitialized: function() {
			$('.owl-nav div').attr('role', 'button');
			$('.owl-nav div:not(.disabled)').attr('tabindex', '0');
			$('.owl-nav .disabled').attr('tabindex', '-1');

			$(document.documentElement).keyup(function (e) {
				var target = $(e.target),
					$owl = $(target).closest('.owl-carousel'),
					action = null;

				if (e.which === 13 && $owl.length) {
					if (target.hasClass('owl-prev')) action = 'prev.owl.carousel';
					else if (target.hasClass('owl-next')) action = 'next.owl.carousel';

					if (action) {
						$owl.trigger(action);
					}
				}
			});
		},

		onTranslated: function() {
			$('.owl-nav div:not(.disabled)').attr('tabindex', '0');
			$('.owl-nav .disabled').attr('tabindex', '-1');
		}
	});

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

site.store = {
	init: function () {
		var $body = $('body');
		$body.on('click', '#storeCart .showMore', function (e) {
			e.preventDefault();
			$('body').toggleClass('cart-open');
			var open = ($body.hasClass('cart-open'));
			$(this).attr('aria-expanded', open);
		});

		$body.on('click', function (e) {
			if ($body.hasClass('cart-open')) {
				if (!$(e.target).parents('#storeCart').length) {
					$('body').removeClass('cart-open');
					$('.showMore', '#storeCart').attr('aria-expanded', false);
				}
			}
		});

		$(document).keydown(function (e) {
			if (e.which === 27 && $body.hasClass('cart-open')) {
				$('body').removeClass('cart-open');
				$('.showMore', '#storeCart').attr('aria-expanded', false);
			}
		});

		//Store
		if ($body.hasClass('store')) {
			site.owl.init('.product .albumImages', {
				loop: false,
				dots: false,
				nav: true,
				items: 4,
				navText: ["", ""],
				margin: 10,
				responsive: {
					0: {
						items: 2
					},
					480: {
						items: 4
					}
				}
			});

			$('.like, .pin', '.product .social').click(function(){
				$(this).toggleClass('open');
			});
		}

		//Checkout
		if ($body.hasClass('checkout')) {
			$('#billing-billingSameAsShipping').change(function() {
				var $fieldset = $('#fieldset-billing').toggleClass('disabled');
				if ($fieldset.hasClass('disabled')) {
					$fieldset.find('input:not(.checkbox)').attr('disabled', 'disabled');
				}
				else {
					$fieldset.find('input:not(.checkbox)').attr('disabled', null);
				}
			}).change();

			$('ul.paymentTypeSelection li').click(function(){
				$(this).siblings().removeClass('selected');
				$(this).addClass('selected');
			});
		}
	},
	showMiniCart: function() {
		setTimeout(function() {
			$('#storeCart a.cart').trigger('click');

		},1000);
	},
};

site.inits.push('site.store.init()');

store = window.store || {};
store.local = store.local || {};
store.local.onUpdateVariantData = function(variant) {
	var attributes = '';
	$.each(variant.attributes, function(attrIdx, attr) {
		attributes += attr + ' / ';
	});
	attributes = attributes.substr(0, attributes.length - 3);

	$('.product .attributes').html(attributes);
};

store.local.updateMiniCart = function(autoOpenSite) {
	$.get(store.url(store.action.cartMedium, ''), function (data) {
		$('.cartBoxMedium').replaceWith(data.html);
		if (autoOpenSite) {
			site.store.showMiniCart();
		}
	}, 'json');
	$.get(store.url(store.action.cartBox, ''), function (data) {
		$('.miniCart').replaceWith(data.html);
	}, 'json');
};

store.local.onAddToCart = function() {
	store.local.updateMiniCart(true);
};

store.local.onCartIncrease = function() {
	store.local.updateMiniCart();
};

store.local.onCartDecrease = function() {
	store.local.updateMiniCart();
};

store.local.initAlbumImages = function() {
	$('ul.albumImages a').click(function(e) {
		e.preventDefault();
		$href = $(this).attr('href');
		$src = $(this).data('image');
		$image = $('.images .image');

		if ($src != $('img', $image).attr('src')) {
			$image.append('<div class="loading">')
			$('a', $image).attr("href", $href);
			$('img', $image).attr("src", $src).load(function() {
				$('.loading',$image).remove();
			});
		}
	});
};
